var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "form",
    attrs: {
      title: `Update ${_vm.membershipPrice.name}`,
      saveChanges: _vm.valid && _vm.currentPrice.id !== _vm.form.newPriceId,
      textSubtitle: "Mass update price for all selected memberships",
      persistent: "",
    },
    on: {
      success: function ($event) {
        return _vm.$emit("success")
      },
      reset: function ($event) {
        return _vm.$emit("reset")
      },
      submit: _vm.submit,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-col gap-4" },
              [
                _c("v-select", {
                  staticClass: "soli-round",
                  attrs: {
                    rules: _vm.rules.select,
                    "error-messages": _vm.errors.newPriceId,
                    outlined: "",
                    dense: "",
                    label: "Select Price",
                    "error-message": "errors.price",
                    "item-text": "formatAmount",
                    "item-value": "id",
                    "hide-details": "auto",
                    items: _vm.locationPrices,
                  },
                  model: {
                    value: _vm.form.newPriceId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "newPriceId", $$v)
                    },
                    expression: "form.newPriceId",
                  },
                }),
                _vm._v(" "),
                _vm.form.newPriceId === 0
                  ? _c("v-currency-field", {
                      staticClass: "soli-round",
                      attrs: {
                        rules: _vm.priceRules,
                        "error-messages": _vm.errors.inlinePrice,
                        outlined: "",
                        dense: "",
                        label: "Custom Price",
                        "error-message": "errors.amount",
                        "prepend-inner-icon": "attach_money",
                        "hide-details": "auto",
                      },
                      model: {
                        value: _vm.form.inlinePrice,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "inlinePrice", $$v)
                        },
                        expression: "form.inlinePrice",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.newPriceId !== _vm.currentPrice.id &&
                ((_vm.form.newPriceId === 0 && _vm.form.inlinePrice !== null) ||
                  _vm.form.newPriceId)
                  ? _c(
                      "div",
                      { staticClass: "soli-grey text-subtitle-2" },
                      [
                        _c("p", { staticClass: "px-1 mb-4" }, [
                          _vm._v(
                            "\n                    This will update the recurring monthly price for all\n                    selected memberships, effective on their next billing\n                    cycle. No proration will be charged.\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-0",
                          attrs: {
                            rules: _vm.rules.select,
                            label: "I Understand",
                            "hide-details": "auto",
                          },
                          model: {
                            value: _vm.form.understand,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "understand", $$v)
                            },
                            expression: "form.understand",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v
      },
      expression: "valid",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }